<span>{{ 'AUTOMATIONS.EDITOR.TRIGGERS.BILLING_PURCHASE.ACTION.WHEN_BILLING_DESCRIPTION' | translate }}</span>

<glxy-select-input [options]="approvalOptions" [formControl]="approvalControl"></glxy-select-input>

<h4>{{ 'AUTOMATIONS.EDITOR.TRIGGERS.BILLING_PURCHASE.ACTION.EXCLUDED_PRODUCTS_DESCRIPTION' | translate }}</h4>
<ul>
  <li>{{ 'AUTOMATIONS.EDITOR.TRIGGERS.BILLING_PURCHASE.ACTION.PRODUCTS_YOU_HAVE_CREATED' | translate }}</li>
  <li>{{ 'AUTOMATIONS.EDITOR.TRIGGERS.BILLING_PURCHASE.ACTION.SNAPSHOT_CREATE' | translate }}</li>
  <li>{{ 'AUTOMATIONS.EDITOR.TRIGGERS.BILLING_PURCHASE.ACTION.SNAPSHOT_REFRESH' | translate }}</li>
  <li>{{ 'AUTOMATIONS.EDITOR.TRIGGERS.BILLING_PURCHASE.ACTION.REP_MAN_TRIAL' | translate }}</li>
  <li>{{ 'AUTOMATIONS.EDITOR.TRIGGERS.BILLING_PURCHASE.ACTION.LISTING_BUILDER_BASE' | translate }}</li>
  <li>{{ 'AUTOMATIONS.EDITOR.TRIGGERS.BILLING_PURCHASE.ACTION.REP_MAN_EXPRESS' | translate }}</li>
  <li>{{ 'AUTOMATIONS.EDITOR.TRIGGERS.BILLING_PURCHASE.ACTION.SOCIAL_MRKT_EXPRESS' | translate }}</li>
  <li>{{ 'AUTOMATIONS.EDITOR.TRIGGERS.BILLING_PURCHASE.ACTION.WEBSITE_PRO_EXPRESS' | translate }}</li>
  <li>{{ 'AUTOMATIONS.EDITOR.TRIGGERS.BILLING_PURCHASE.ACTION.CUSTOMER_VOICE' | translate }}</li>
  <li>{{ 'AUTOMATIONS.EDITOR.TRIGGERS.BILLING_PURCHASE.ACTION.AD_INTEL_EXPRESS' | translate }}</li>
  <li>{{ 'AUTOMATIONS.EDITOR.TRIGGERS.BILLING_PURCHASE.ACTION.CALENDAR_HERO' | translate }}</li>
</ul>
